import * as React from 'react';import { SelectionReportContainer, FrequencyReportContainer } from 'app/area/reports';
import { reportTypes } from './constants';
import { FavouriteResultComponentProps } from './types';
import { CaseReport } from 'app/area/case-report';
import { RiskReportContainer } from 'app/area/case-report/risk-listing/risk-report-container';

const renderers = {
  [reportTypes.selectionReport]: SelectionReportContainer,
  [reportTypes.frequencyReport]: FrequencyReportContainer,
  [reportTypes.riskReport]: RiskReportContainer,
  [reportTypes.mergedReport]: (() => <div>Not implemented</div>)
};

export const FavouriteResult = (
  props:
    FavouriteResultComponentProps
) => {

  const { report } = props;
  const Component = renderers[report];

  if (!!Component) {
    return <Component {...props} {...(props?.statisticalReportExternalProps ?? {})} />;
  }

  return <CaseReport {...props} {...(props?.caseReportExternalProps ?? {})} />;
};
